import React, { PureComponent } from 'react';

class Help extends PureComponent {
    render(){
        return (
            <div className="thanks section">
                <p>付款已取消<br/>

                <a href="/">按此返回首頁</a></p>
            </div>
        );
    }
}
export default Help;